module.exports = __webpack_public_path__ + "static/mingyu-wu-a52af9a5a6ef61c458f46db6cb56b5b1.jpg";